/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetFlagReleaseSettingsPathParams = NonNullable<operations['GetFlagReleaseSettings']['parameters']['path']>;

export interface Input extends GetFlagReleaseSettingsPathParams {
  apiVersion?: string;
  header: NonNullable<operations['GetFlagReleaseSettings']['parameters']['header']>;
}

export async function GetFlagReleaseSettings(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/release-settings',
    {
      params: { path, header },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
